const Config = {
	debug: true,
	maxLogMinutes: 5,
	logTimeVerification: 60000,
	minScoreRepprovedPrinciple: 2
}

export default Config;
